import Skeleton from 'react-loading-skeleton';
import cx from 'classnames';

import s from './styles.module.scss';
import 'react-loading-skeleton/dist/skeleton.css';

const DEFAULT_ROWS = 5;
const DEFAULT_COLUMNS = 3;

type TableSkeletonProps = {
  className?: string;
  rows?: number;
  columns?: number;
};

export const TableSkeleton = ({ className, rows = DEFAULT_ROWS, columns = DEFAULT_COLUMNS }: TableSkeletonProps) => {
  const cellCount = rows * columns;
  return (
    <div
      className={cx(s.containerBody, s.tableSkeleton, className)}
      style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
    >
      {Array.from({ length: cellCount }, (_, i) => (
        <Skeleton key={i} height={35} inline />
      ))}
    </div>
  );
};
